import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Differentials from './components/Differentials';
import Benefits from './components/Benefits';
import Structure from './components/Structure';
import ScheduleVisit from './components/ScheduleVisit';
import Enrollment from './components/Enrollment';
import About from './components/About';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import Partners from './components/Partners';
import Location from './components/Location';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Differentials />
      <Benefits />
      <Structure />
      <ScheduleVisit />
      <Enrollment />
      <About />
      <Gallery />
      <Reviews />
      <Partners />
      <Enrollment />
      <Location />
      <Footer />
    </div>
  );
}
